import { useQuery } from "@tanstack/react-query"
import { campaignsActivityQuery } from "../lib/campaignsActivityQuery"

export function useCampaignsActivityQuery(...args: Parameters<typeof campaignsActivityQuery>) {
  return useQuery(campaignsActivityQuery(...args))
}
